import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './index.less'

function Brand(props) {
  const navigate = useNavigate()

  function handleClick(e) {
    navigate(`home`)
  }

  return (
    <div className={styles['brand']} onClick={() => {handleClick()}}>
      <div className={styles['brand-logo']}>
        <img src={require('@images/logo.png')} alt="" />
      </div>
      <div className={styles['brand-name']}>武汉风行在线技术有限公司</div>
    </div>
  )
}

export default Brand
